import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';
import { token } from '@atlaskit/tokens';
import Heading from '@atlaskit/heading/heading';

import { expVal } from '@confluence/feature-experiments';

const i18n = defineMessages({
	connections: {
		id: 'byline-connections.menu.header.title-teamwork-graph.do-not-translate',
		defaultMessage: 'Teamwork Graph',
		description:
			'Title shown at the top of the connections byline menu, which lists the links and apps connected to the current page. "Teamwork Graph" is a product name and is intentionally not translated.',
	},
	subtitle: {
		id: 'byline-connections.menu.header.subtitle',
		defaultMessage: 'Links and apps connected to this page',
		description:
			'Subheading shown below the title in the connections byline menu, describing that the menu lists links and apps connected to the current page.',
	},
	connectionsTwg: {
		id: 'byline-connections.menu.header.title-teamwork-graph-twg.do-not-translate',
		defaultMessage: 'Teamwork Graph',
		description:
			'Title shown at the top of the connections byline menu, which lists the links and references connected to the current page. "Teamwork Graph" is a product name and is intentionally not translated.',
	},
	subtitleTwg: {
		id: 'byline-connections.menu.header.subtitle-twg-v2',
		defaultMessage: "See how this content connects to your team's work",
		description:
			"Subheading shown below the title in the connections byline menu, describing that the menu shows how the current page connects to the team's work.",
	},
});

const styles = cssMap({
	header: {
		paddingBlockStart: token('space.150'), // 12px above the heading
		paddingBlockEnd: token('space.100'), // 8px below the subtitle
		paddingInline: token('space.200'),
	},
});

export const HEADER_HEADING_ID = 'byline-connections-heading';

export const ConnectionsByLineMenuHeader = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Stack xcss={styles.header} space="space.050">
			<Heading id={HEADER_HEADING_ID} size="medium">
				{formatMessage(
					expVal('1p_3p_connections_byline_twg', 'isEnabled', false)
						? i18n.connectionsTwg
						: i18n.connections,
				)}
			</Heading>
			<Text as="p" size="small" color="color.text.subtlest">
				{formatMessage(
					expVal('1p_3p_connections_byline_twg', 'isEnabled', false)
						? i18n.subtitleTwg
						: i18n.subtitle,
				)}
			</Text>
		</Stack>
	);
};
